import { Typography } from "antd";
const { Text } = Typography;
import { COLORS } from "../../const";

export function TableColumnHeader({ text }) {
  return (
    <Text
      style={{
        color: COLORS.deepBlue,
        fontSize: 14,
        fontWeight: 500,
        inlineSize: "max-content",
      }}
    >
      {text}
    </Text>
  );
}
